import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/AdminHeader.module.css";

interface User {
  id: number;
  username: string;
  email: string;
  isAdmin: boolean;
}

interface AdminHeaderProps {
  user?: User;
  apiUrl: string;
}

const AdminHeader: React.FC<AdminHeaderProps> = ({ user, apiUrl }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const res = await fetch(`${apiUrl}/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
      if (res.ok) navigate("/");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return (
    <header className={styles.headerContainer}>
      {/* Logo */}
      <div className={styles.logo}>
        <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Greystar Motors" />
      </div>

      {/* Hamburger for mobile */}
      <button
        className={styles.menuToggle}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        ☰
      </button>

      {/* Navigation */}
      <nav className={`${styles.nav} ${menuOpen ? styles.open : ""}`}>
        <ul className={styles.navList}>
          <li className={styles.userGreeting}>
            {user ? `Welcome, ${user.username}` : "Loading..."}
          </li>
          <li>
            <button
              className={styles.navButton}
              onClick={() => navigate("/admin/home")}
            >
              🏠 Dashboard
            </button>
          </li>
          <li>
            <button
              className={styles.navButton}
              onClick={() => navigate("/admin/orders")}
            >
              🛒 Orders
            </button>
          </li>
          <li>
            <button
              className={styles.navButton}
              onClick={() => navigate("/admin/reviews")}
            >
              ⭐ Reviews
            </button>
          </li>
          <li>
            <button
              className={styles.navButton}
              onClick={() => navigate("/admin/users")}
            >
              👤 Users
            </button>
          </li>
          <li>
            <button
              className={`${styles.navButton} ${styles.logoutButton}`}
              onClick={handleLogout}
            >
              Logout
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default AdminHeader;
